import script from "./ArticleEmbeddedMedia.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleEmbeddedMedia.vue?vue&type=script&setup=true&lang=js"

import "./ArticleEmbeddedMedia.vue?vue&type=style&index=0&id=63c0486a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63c0486a"]])

export default __exports__